export const app = {
  namespaced: true,
  state: {
    name: "Evdeki Öğretmen",
    version: "v2.0.0",
    incomplete_completion:  true,
    home_work: true,
    report: false
  },
  getters: {
    getAppName (state) {
      return state.name;
    },
  },
  actions: {
    incompleteCompletionStatus({ commit }, data) {
      commit('changeIncompleteCompletionStatus', data)
    }
  },
  mutations: {
    changeIncompleteCompletionStatus: (state, payload) => {
      const { status } = payload
      state.incomplete_completion = status
    }
  }
};